import axios from "axios";
import { config } from "../config/config";
import Cookies from "js-cookie";

const axiosInstanceJson = axios.create({
  baseURL: config.base.url,
  timeout: 5000,
  withCredentials: true,
});

// Request interceptor
axiosInstanceJson.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    const token = Cookies.get("authToken", { path: "/" });
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstanceJson.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      handleUnauthorized();
      return Promise.resolve();
    }
    if (error.response) {
      error.message = `Request failed with status ${error.response.status}`;
    }
    return Promise.reject(error);
  }
);

const handleUnauthorized = () => {
  // Remove with same parameters as set
  Cookies.remove("authToken", {
    domain: config.domain,
    path: "/",
    secure: config.ENVIRONMENT === "prod",
    sameSite: "Strict",
  });

  if (typeof window !== "undefined") {
    // Add timeout to ensure cookie is removed before redirect
    setTimeout(() => {
      window.location.href = "/";
    }, 100);
  }
};

export default axiosInstanceJson;
